var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("multiselect", {
    attrs: {
      options: _vm.records,
      multiple: true,
      label: "selectTitle",
      "track-by": "selectTitle",
      placeholder: _vm.options?.placeholder || "Выберите вариант",
      "select-label": "Выбрать",
      "deselect-label": "Удалить",
    },
    on: { input: _vm.updateSelected },
    model: {
      value: _vm.selectedRecords,
      callback: function ($$v) {
        _vm.selectedRecords = $$v
      },
      expression: "selectedRecords",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }